var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogosGitlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M13.336 24.558L18.244 9.451 8.427 9.451 13.336 24.558z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M13.336 24.558L8.427 9.451 1.548 9.451z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M1.548 9.451L.056 14.042c-.136.419.013.878.37 1.136l12.91 9.38L1.548 9.451z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M1.548 9.451h6.88L5.47.352c-.152-.468-.815-.468-.967 0l-2.956 9.1z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M13.336 24.558L18.244 9.451 25.124 9.451 13.336 24.558z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M25.124 9.451l1.491 4.591c.136.419-.013.878-.369 1.136l-12.91 9.38L25.124 9.451z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M25.124 9.451h-6.88L21.201.352c.152-.468.814-.468.966 0l2.957 9.1z",
    transform: "translate(-181 -305) translate(165 274) translate(16 31) translate(2.667 4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogosGitlab);
export default __webpack_public_path__ + "static/media/icon-logos-gitlab.ea949780.svg";
export { ForwardRef as ReactComponent };